<mat-card appearance="outlined">
  <div class="header">
    @if (icon) {
      <mat-icon class="icon">{{ icon }}</mat-icon>
    }
    <h3 class="title" tabindex="-1">{{ title }}</h3>
    @if (description) {
      <!-- Toggled on click too, as a touch screen has no hover. -->
      <button
        mat-icon-button
        type="button"
        class="info"
        [matTooltip]="description"
        #tip="matTooltip"
        [attr.aria-label]="description"
        (click)="tip.toggle()"
      >
        <mat-icon>info_outline</mat-icon>
      </button>
    }
  </div>
  <mat-card-content class="body">
    <ng-content></ng-content>
  </mat-card-content>
  @if (showNext) {
    <mat-card-actions align="end">
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="next.emit()"
      >
        {{ 'next' | i18nextCap }}
      </button>
    </mat-card-actions>
  }
</mat-card>
